import type { Activity_category } from "@prisma/client";

// 活動記録の内容
export const ACTIVITIES: { activity: Activity_category; wording: string }[] = [
  { activity: "POST_FUMUFUMU", wording: "フムフムに投稿しました" },
  {
    activity: "POST_FUMUFUMU_COMMENT",
    wording: "フムフムにコメントを追加した",
  },
  { activity: "SEND_GOOD", wording: "いいねしました" },
  { activity: "SEND_WAKARU", wording: "ワカルしました" },
  { activity: "CHANGE_CLOTHS", wording: "着替えました。" },
  { activity: "RANK_IN", wording: "位に入りました" },
  { activity: "GET_BADGE", wording: "バッジを獲得しました" },
  { activity: "SEND_FOLLOW", wording: "フォローしました" },
  { activity: "RECEIVE_FOLLOW", wording: "フォローされました" },
];
